const axios = require('axios').default;

export default function postRequest(url: string, body: object, config: object = {}) {
    return axios.post(url, body, {...config, timeout: 30000});
}